import { TODO } from '@b2c/types/index';
import angular from 'angular';
import { RatingsDirectiveModule } from '../ratings/ratings.directive';
import { SumDirectiveModule } from '../sum/sum.directive';
import { SalesRuleServiceModule } from '@b2c/common/services/salesRule/salesRule.service';
import { DiscountServiceModule } from '@b2c/common/services/discount/discount.service';
import { OrdersServiceModule } from '@b2c/common/services/order/order.service';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { CartServiceModule } from '@b2c/common/services/cart/cart.service';
import { MembershipHeadingDirectiveModule } from '../membershipHeading/membershipHeading.directive';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { ComboServiceModule } from '@b2c/common/services/combo/combo.service';
import { CalendarServiceModule } from '@b2c/common/services/calendar/calendar.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';

export const EventDirectiveModule = angular.module('acme.common.directive.event', [
  'ui.bootstrap',
  SumDirectiveModule,
  RatingsDirectiveModule,
  MembershipHeadingDirectiveModule,
  CartServiceModule,
  OrdersServiceModule,
  EventsServiceModule,
  ComboServiceModule,
  DiscountServiceModule,
  CalendarServiceModule,
  HelpersServiceModule,
  MembershipServiceModule,
  SalesRuleServiceModule,
  AnalyticsServiceModule,
  ThemesServiceModule
])
.directive('event', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/event/event.tpl.html',
      scope: {
        mode: '=',
        model: '=',
        gaExists: '=',
        eventDates: '=',
        ticketQuantity: '=',
        action: '&',
        actionAdd: '&',
        actionEdit: '&',
        actionRemove: '&',
        actionChange: '&',
        actionSelected: '&',
        actionRequires: '&',
        addText: '@',
        editText: '@',
        removeText: '@',
        selectedText: '@',
        changeDateText: '@',
        selectedComboEventTemplateIds: '@',
        type: '@',
        endTime: '@',
        startTime: '@',
        loadHours: '@',
        disableActions: '@',
        autoSelectTime: '@',
        showPrice: '@',
        showReviews: '=',
        remaining: '=',
        venueHours: '@',
        verifyMembership: '&',
      },
      
      link: function($scope, $element, $attrs, $ctrl) {
        // Modified after controller runs

      },

      controller: ['$scope', '$state', '$filter', '$timeout', '$sce', 'EventsService', 'CartService', 'OrderService', 'ComboService', 'DiscountService', 'CalendarService', 'HelpersService', 'MembershipService', 'SalesRuleService', 'AnalyticsService', 'ThemesService', function($scope, $state, $filter, $timeout, $sce, EventsService, CartService, OrderService, ComboService, DiscountService, CalendarService, HelpersService, MembershipService, SalesRuleService, AnalyticsService, ThemesService) {

        $scope.event = {

          GA: false, // TODO: Cleanup after DEMO
          showAllSchedules: false,
          maxShownSchedules: 2,
          isLoaded: false,

          tenantId: false,
          membershipIds: false,
          membershipIdsWithoutGracePeriod: false,

          prerequisite: {},
          model: {},
          processed: {},
          hours: [],
          moreHours: [],
          comboEvents: [],

          autoSelectSlots: 5,

          mode: 'view',
          type: 'event',
          include: '',
          ticketTotal: 0,
          ticketTotalQuantity: 0,
          discountTotal: 0,
          discountQuantities: {},
          showHours: false,
          hasPrices: true,
          isMaxed: false,
          isChoosing: false,
          isAtCapacity: false,
          autoSelectTime: false,
          addText: '',
          editText: '',
          removeText: '',
          selectedText: '',
          changeDateText: '',
          requiresText: '',
          selectedHour: '',
          selectedHourId: '',
          selectedComboEventTemplateIds: '',
          selectedHourAvailableSeats: 0,
          disabledActions: [],
          displayStartTime: '',

          changedDates: false,
          changeDateIds: {},

          availableSeatsWatcher: false,
          remainingSeats: 0,

          allowMembershipSales: false,

          memberDiscountedPriceMap: {},

          memberTicketLimitMap: {},
          memberGroupLimitMap: {},
          ticketLimitGroups: {},

          eventHoursLoaded: false,

          isTimeFromURL: false,

          text: {
            fullPrice: ThemesService.getTextVariable('event-full-price-title', 'full price tickets'),
            discountPrice: ThemesService.getTextVariable('event-discounted-price-title', 'discounted tickets'),
            eventPrice: ThemesService.getTextVariable('event-event-price-title', 'tickets'),
            limitExceeded: ThemesService.getTextVariable('event-limit-exceeded-title', 'Ticket Limit'),
            orderLimitExceeded: ThemesService.getTextVariable('order-limit-exceeded-title', 'Ticket Limit per order'),
            retailPrice: ThemesService.getTextVariable('event-retail-price-title', 'full price tickets'),
            eventSalesLimit: ThemesService.getTextVariable('event-sales-conflict-title', 'These tickets are no longer available for the selected time: '),
            eventSalesLimitInCart: ThemesService.getTextVariable('event-sales-conflict-in-cart-title', 'These tickets cannot be purchased together at these quantities for the selected time: '),
            lastTicketsAvailable: ThemesService.getTextVariable('event-last-tickets-available', 'There are not enough tickets available. Please adjust your quantity.')
          },

          hasLimitErrors: false,
          verifiedMember: false,
          memberOnlyEvent: false,
          memberCanPurchase: false,
          hasMembershipInCart: false,
          hasEligibleMembershipInCart: false,

          init: function() {
            var isExpiredMembership = MembershipService.checkExpiredVerifiedMembership($state.params.tenantId);

            this.model = $scope.model;

            if ($scope.type) {
              this.type = $scope.type;
            }

            if ($state.params) {
              if ($state.params.tenantId) {
                this.tenantId = $state.params.tenantId;
              }
              if ($state.params.membershipIds) {
                this.membershipIds = isExpiredMembership ? null : MembershipService.getMembershipIds(true, $state.params.membershipIds.split(',')).join();
                this.membershipIdsWithoutGracePeriod = isExpiredMembership ? null : MembershipService.getMembershipIds(true, $state.params.membershipIds.split(','), true).join();
              } else {
                this.membershipIds = isExpiredMembership ? null : MembershipService.getMembershipIds(true).join();
                this.membershipIdsWithoutGracePeriod = isExpiredMembership ? null : MembershipService.getMembershipIds(true, false, true).join();
              }

              this.changeDateIds = {
                eventIds: $state.params.cdEventIds || false,
                date: $scope.startTime
              };

              this.changedDates = CartService.getChangedDates((this.isEventType('combo') ? 'combo' : 'event'), this.changeDateIds.eventIds, this.changeDateIds.date);
            }

            console.log('Event::init', this.model);

            this.allowMembershipSales = ThemesService.getCompany('membershipSales');

            if (this.isEventType('combo')) {
              this.eventHoursLoaded = true;
              if ($scope.selectedComboEventTemplateIds) {
                this.selectedComboEventTemplateIds = $scope.selectedComboEventTemplateIds;
                console.log('Event::init', this.selectedComboEventTemplateIds);
                this.processComboEvents();
              }
            }else{
              if (this.changedDates && this.changedDates[this.model.id]) {
                this.model.selectedDate = this.changedDates[this.model.id];
              }else{
                this.model.selectedDate = CartService.getCartDate(this.model);
              }
              if (this.model.selectedDate) {
                $scope.startTime = CalendarService.toISO8601(CalendarService.getParsableDate(this.model.selectedDate));
              }
            }

            this.processEvent();

            if (!$scope.startTime) {
              $scope.startTime = CalendarService.toISO8601(new Date());
            }

            this.displayStartTime = $filter('date')(CalendarService.getParsableDate($scope.startTime), 'EEEE, MMMM d, yyyy');
            console.log('Event::init', this.model.startTime, $scope.startTime, this.displayStartTime);


            this.isChoosing = ($scope.editMode);
            this.addText = $scope.addText || 'Tickets';
            this.editText = $scope.editText || 'Change Time';
            this.removeText = $scope.removeText || 'Remove Item';
            this.selectedText = $scope.selectedText || 'Remove Item';
            this.changeDateText = $scope.changeDateText || 'Change Date';
            this.autoSelectTime = $scope.autoSelectTime || false;

            switch ($scope.mode) {
              case 'GA':
                /* falls through */
              case 'view':
                /* falls through */
              case 'carted':
                /* falls through */
              case 'selected':
                /* falls through */
              case 'added':
                this.mode = $scope.mode;
                break;
              default:
                this.mode = 'view';
            }

            if ($scope.loadHours) {
              if (!this.isEventType('combo')) {
                this.getHours();
              } else {
                this.eventHoursLoaded = true;
              }
            } else {
              this.eventHoursLoaded = true;
            }

            // TODO: Only for DEMO need to remove this special case
            this.GA = EventsService.hasGAPrerequisiteEvent(this.model, true);
            if (this.GA !== false) {
              this.requiresText = 'Add Admission';
            }else{
              this.requiresText = $scope.requiresText || 'Buy Tickets';
            }

            this.disableActions();
            this.isGA = EventsService.isGAEvent(this.model);
            //this.checkGAPrerequisite();
            this.checkPrerequisites();

            $scope.event.checkMemberOnlyEvent();

            $scope.$on('OrdersTickets::CartUpdated', function() { 
              $scope.event.checkMemberOnlyEvent(); 
            });
            
            $scope.$on('OrdersTickets::OrdersUpdated', this.onOrdersUpdated);
            $scope.$on('Sum::UpdateTotal', this.onSumUpdateTotal);
            $scope.$on('Inventory::UpdateTotal', this.onSumUpdateTotal);
            $scope.$on('Orders::updatedLimits', this.onOrdersUpdatedLimits);

            $scope.$on('$destroy', $scope.$watch('gaExists', this.onGAExistsUpdate));

          },

          checkMemberOnlyEvent: function() {
            var self = $scope.event;
            var membershipCategoryIdsInCart = CartService.getMemberships('all').map(function(item) { return item.membershipInfo.membershipCategoryId; });
            var memberCanPurchaseFlags = MembershipService.validateMemberCanPurchaseEvent(self.model, membershipCategoryIdsInCart);
            
            self.verifiedMember = MembershipService.getVerifiedMember();
            self.isMemberActive = memberCanPurchaseFlags.isMemberActive;
            self.memberOnlyEvent = memberCanPurchaseFlags.isMemberOnlyEvent;
            self.memberCanPurchase = memberCanPurchaseFlags.result;
            self.hasMembershipInCart = !!membershipCategoryIdsInCart.length;
            self.hasEligibleMembershipInCart = memberCanPurchaseFlags.hasEligibleMembershipInCart;
          },

          showEligibleForDiscountWithValidMembership: function() {
            var self = $scope.event;

            return !self.isMode('added') && self.processed.hasMembershipDiscounts && !self.model.discountAvailable;
          },

          showDiscountsAvailableWithYourMembership: function() {
            var self = $scope.event;

            return !self.isMode('added') && self.processed.hasMembershipDiscounts && self.model.discountAvailable;
          },

          launchMemberVerify: function() {
            var metadata = MembershipService.getMemberVerifyEventMetadata($state.params);

            AnalyticsService.event(metadata.event);
            HelpersService.setHref(metadata.href);
          },

          action: function(type) {
            var actionType = (type) ? HelpersService.cap(type) : '',
                actionName = 'action';

            if ($scope[actionName + actionType] &&
                typeof($scope[actionName + actionType]) === 'function') {
              actionName = actionName + actionType;
            }

            if (this[actionName] &&
                typeof(this[actionName]) === 'function') {
              this[actionName]();
            }

            AnalyticsService.event({
              name: 'Event::Action::' + actionType,
              category: 'Event',
              label: this.model.name + ' (' + this.model.id + ')'
            });

            $scope[actionName]();
          },

          actionEdit: function() {
            this.showHours = true;
          },

          disableActions: function() {
            var d,
                i, ii;

            console.log('Event::disableActions', $scope.disableActions);
            if ($scope.disableActions && typeof($scope.disableActions) === 'string') {
              if ($scope.disableActions.indexOf(',') === -1) {
                this.disabledActions.push($scope.disableActions.replace(/\s+/g, ''));
              }else{
                d = $scope.disableActions.split(',');
                for (i = 0, ii = d.length; i < ii; i++) {
                  this.disabledActions.push(d[i].replace(/\s+/g, ''));
                }
              }
            }
          },

          enableAction: function(action) {
            var index = this.disabledActions.indexOf(action);

            if (index > -1) {
              this.disabledActions.splice(index, 1);
            }
          },

          isDisabledAction: function(action) {
            return ($scope.disableActions && $scope.disableActions.indexOf(action) > -1);
          },

          changeDate: function(comboId, eventTemplateId, eventDate) {
            $scope.$emit('Event::ChangeDate', {
              comboId: comboId,
              eventTemplateIds: this.getComboEventIds(),
              eventTemplateId: eventTemplateId,
              date: eventDate.split('T')[0] + 'T00:00:00'
            });
          },

          isSoldOutTime: function(hour) {
            return (hour.availableSeats === 0);
          },

          isMode: function(mode) {
            return (this.mode === mode);
          },

          isEventType: function(type) {
            return (this.type === type);
          },

          isRange: function(time) {
            return (time.indexOf(' - ') > 0 );
          },

          isDiscountDistributionType: function(type) {
            return (this.model.discountDistributionType === type);
          },

          hasTotalAmountDiscount: function() {
            return (this.model.type === 'discountCode' && this.isDiscountDistributionType('total'));
          },

          hasComboDiscount: function() {
            return (this.model.type === 'discountCode');
          },

          detailClick: function(id) {
            var eventId;

            if (this.isEventType('combo')) {
              if (id) {
                eventId = id;
              }else if (this.model.templates.entries[0].templateId) {
                eventId = this.model.templates.entries[0].templateId;
              }else if (this.model.templates.entries[0].templateIds && this.model.templates.entries[0].templateIds[0]) {
                eventId = this.model.templates.entries[0].templateIds[0];
              }
              console.log('Event::detailClick', this.model.templates.entries[0], eventId);
              $scope.$emit('Event::DetailClick', { comboId: this.model.id, eventId: eventId, type: this.type });
            }else {
              $scope.$emit('Event::DetailClick', { eventId: this.model.id, type: this.type });
            }

            AnalyticsService.event({
              name: 'Event::DetailClick',
              category: 'Event',
              label: this.model.name + ' (' + this.model.id + ')'
            });

          },

          seeMore: function() {
            this.showAllSchedules = true;
          },

          processEvent: function() {
            var i, ii;
            var type;
            var entry;
            var template;
            var comboPreviewImg = false;
            var averageRating = 0;

            if (this.model) {
              this.processed = {
                duration: '',
                eventTimes: '',
                facilityName: '',
                description: (this.model.shortDescription) ? HelpersService.strip(this.model.shortDescription, 300) : HelpersService.strip(this.model.description, 300),
                previewImage: '',
                isMemberEvent: false,
                averageRating: EventsService.getAverageRating(this.model.stars, this.model.ratings),
                related: [],
                events: [],
                hasSalesRules: false
              };

              if (this.isEventType('combo')) {

                if (this.model.templates &&
                    this.model.templates.entries &&
                    this.model.templates.entries instanceof Array) {

                  for (i = 0, ii = this.model.templates.entries.length; i < ii; i++) {
                    entry = this.model.templates.entries[i];

                    if (entry.type === 'any') {
                      this.processed.related.push({
                        events: entry.summaries,
                        quantity: entry.quantity
                      });
                      if (entry.summaries && entry.summaries.length && !comboPreviewImg) {
                        comboPreviewImg = EventsService.getPrimaryImage(entry.summaries[0]).preview ? EventsService.getPrimaryImage(entry.summaries[0]).preview : false;
                      }
                    }else{
                      template = entry.template || entry.summaries[0];
                      if (template) {
                        this.processed.events.push({
                          type: 'combo',
                          id: template.id,
                          name: template.name,
                          duration: EventsService.getDuration(template.duration, this.model.admissionType),
                          //eventTimes: EventsService.getTimes(template.schedules, template.repeatCycle, this.model.admissionType),
                          facilityName: EventsService.getFacilityName(template.resources),
                          description: (template.shortDescription) ? HelpersService.strip(template.shortDescription, 300) : HelpersService.strip(template.description, 300),
                          previewImage: { 'background-image': "url('" + EventsService.getPrimaryImage(template).preview + "')" },
                          hasImage: EventsService.getPrimaryImage(template).preview ? true : false
                        });

                        if (!comboPreviewImg) {
                          comboPreviewImg = EventsService.getPrimaryImage(template).preview ? EventsService.getPrimaryImage(template).preview : false;
                        }
                        averageRating += EventsService.getAverageRating(template.stars, template.ratings);
                        console.log('Event::processEvent', averageRating);
                      }
                    }

                  }

                  if (comboPreviewImg) {
                    this.processed.previewImage = { 'background-image': "url('" + comboPreviewImg + "')" };
                    this.processed.hasImage = true;
                  }

                  this.processed.averageRating = EventsService.getAverageRating(averageRating, ii);
                }
              } else {
                this.processed.duration = EventsService.getDuration(this.model.duration, this.model.admissionType);
                //this.processed.eventTimes = EventsService.getTimes(this.model.schedules, this.model.repeatCycle, this.model.admissionType);
                this.processed.facilityName = EventsService.getFacilityName(this.model.resources);
                this.processed.previewImage =  { 'background-image': "url('" + EventsService.getPrimaryImage(this.model).preview + "')" };
                this.processed.hasImage = EventsService.getPrimaryImage(this.model).preview ? true : false;

                if (this.checkMembershipHasDiscounts(this.model.membership)) {
                  type = 'member';
                  this.processed.hasMembershipDiscounts = true;
                } else {
                  type = 'event';
                }

                this.processed.hasSalesRules = EventsService.hasSalesRules(this.model);
                this.processed.events.push({
                  type: type,
                  name: this.model.name,
                  duration: this.processed.duration,
                  eventTimes: this.processed.eventTimes,
                  facilityName:this.processed.facilityName,
                  description: this.processed.description,
                  previewImage: this.processed.previewImage,
                  hasImage: this.processed.hasImage
                });
              }

            }
          },

          processComboEvents: function() {
            var i, ii,
                ids,
                dates;

            if (this.changedDates && this.changedDates[this.model.id]) {
              dates = this.changedDates[this.model.id];
            }

            ids = (this.selectedComboEventTemplateIds.indexOf(',') > 0) ? this.selectedComboEventTemplateIds.split(',') : [this.selectedComboEventTemplateIds];
            console.log('Event::processComboEvents',  ids);
            for (i=0,ii=ids.length;i<ii;i++) {
              this.comboEvents.unshift(ComboService.findEventTemplate(this.model, ids[i]));
              if(dates) {
                console.log('Event::processComboEvents', dates.defaultDate,  dates[ids[i]], ids[i], $scope.startTime, this.comboEvents[0].selectedDate);
              }else {
                console.log('Event::processComboEvents', $scope.startTime, this.comboEvents[0].selectedDate);
              }
              // Check to see if we are editing an existing date
              if (dates && dates[ids[i]]) {
                this.comboEvents[0].selectedDate = dates[ids[i]];
              }else if (!this.comboEvents[0].selectedDate) {
                this.comboEvents[0].selectedDate = $scope.startTime;
              }

              this.comboEvents[0].hours = this.getComboHours(ids[i], this.model.id);
            }
            console.log('Event::processComboEvents', this.comboEvents);
          },

          findComboEvent: function(id) {
            let r: { index: number; event: TODO; } | false = false;

            for (let i = 0, ii = this.comboEvents.length; i < ii; i++) {
              if (this.comboEvents[i].id === id) {
                r = {
                  index: i,
                  event: this.comboEvents[i]
                };
                break;
              }
            }

            return r;
          },

          getComboEventIds: function() {
            const r: TODO[] = [];

            for (let i = 0, ii = this.comboEvents.length; i < ii; i++) {
              r.unshift(this.comboEvents[i].id);
            }

            return r;
          },

          getSlotTime: function(time) {
            return EventsService.getSlotTime(time);
          },

          getHour: function(id) {
            var r = this.findHour(id);

            // If there is an already existing selected time that is invalid
            // Make sure to assign the first available time anyway
            if (r === false && this.model.selectedHourId) {
              r = this.hours[0];
              this.model.selectedHourId = r.id;
            }

            this.selectedHourAvailableSeats = r.availableSeats;
            this.remainingSeats = r.availableSeats;

            console.log('Event::getHour', this.selectedHourAvailableSeats);

            return r;
          },

          findHour: function(id) {
            var i, ii,
              r = false;

            for (i = 0, ii = this.hours.length; i < ii; i++) {
              if (this.hours[i].id === id) {
                r = this.hours[i];
                break;
              }
            }
            return r;
          },

          getComboHour: function(id: string, event: TODO) {
            let result: { id: string; availableSeats: TODO[] } | false = false;

            for (let i = 0, ii = event.hours.length; i < ii; i++) {
              if (event.hours[i].id === id) {
                result = event.hours[i];
                break;
              }
            }

            // If there is an already existing selected time that is invalid
            // Make sure to assign the first available time anyway
            if (result === false && event.selectedHourId && event.hours.length > 0) {
              result = event.hours[0];
              
              if (result) {
                event.selectedHourId = result.id;
              }
            }

            if (result) {
              event.selectedHourAvailableSeats = result.availableSeats;
              event.remainingSeats = result.availableSeats;
              this.remainingSeats = 100;
            }

            console.log('Event::getComboHour', event.selectedHourId);

            return result;
          },

          isMemberVerified: function() {
            return this.membershipIds;
          },

          getMembershipLabel: function() {
            return (this.isMemberVerified() && this.allowMembershipSales) ? 'View memberships' : 'Verify your membership';
          },

          hasVenueHours: function() {
            return $scope.venueHours || false;
          },

          hasAddOns: function() {
            return (this.model.hasOwnProperty('addOns'));
          },

          checkMembershipHasDiscounts: function(membership) {
            return membership && Array.isArray(membership.discounts) && membership.discounts.length > 0;
          },

          //This is a temp solution till backend gives us retail price and discounted price in the template and times calls.
          //TODO: Must revert to the commented code below.
          hasDiscountPrice: function(ticket, eventId) {
            // return ticket.price && ticket.discountedPrice && (ticket.price !== ticket.discountedPrice);
            return this.getRetailPriceForTicketDiscount(eventId, ticket.personType.id);
          },

          //This is a temp solution till backend gives us retail price and discounted price in the template and times calls.
          //TODO: Must revert to the commented code below.
          hasAtleastOneDiscountPrice: function(eventId) {
            var self = $scope.event,
                r = false,
                i, ii;

            if (this.model.priceLists instanceof Array &&
              this.model.priceLists[0] &&
              this.model.priceLists[0].prices instanceof Array) {
              for (i=0, ii=self.model.priceLists[0].prices.length; i < ii; i++) {
                if (self.getRetailPriceForTicketDiscount(eventId, self.model.priceLists[0].prices[i].personType.id)) {
                  r = true;
                  break;
                }
              }
            }

            return r;
          },

        launchMembership: function() {
            if (!this.isMemberVerified() || !this.allowMembershipSales) {
              $scope.verifyMembership({ $event: { eventTemplateId: this.model.id }});
            } else {
              var url = HelpersService.makeUrl(['/membership', this.tenantId, 'join']);
              HelpersService.setHref(url);
            }
          },

          // Associates eventIds with membership discounts and the membership level info
          processMemberDiscountPrices: function(membershipDiscounts) {
            var i, ii,
              found,
              memberDiscountedPriceMap = {},
              membershipDiscountItems,
              getPricesMap = function(prices) {
                var r = {},
                  personTypeId;
                prices.forEach(function(price) {
                  personTypeId = price.personTypeId;
                  r[personTypeId] = price;
                });
                return r;
              };

            for (i=0, ii=membershipDiscounts.length; i < ii; i++) {
              found = this.findHour(membershipDiscounts[i].eventId);

              if (found !== false) {
                if (!memberDiscountedPriceMap.hasOwnProperty(membershipDiscounts[i].eventId)) {
                  memberDiscountedPriceMap[membershipDiscounts[i].eventId] = [];
                }
                membershipDiscountItems = memberDiscountedPriceMap[membershipDiscounts[i].eventId];
                membershipDiscountItems.push({
                  membershipId: membershipDiscounts[i].membershipId,
                  membershipLevelId: membershipDiscounts[i].membershipLevelId,
                  membershipLevelName: membershipDiscounts[i].membershipLevelName,
                  membershipLevelCollectionName: membershipDiscounts[i].membershipLevelCollectionName,
                  prices: getPricesMap(membershipDiscounts[i].prices)
                });
              }
            }
            return memberDiscountedPriceMap;
          },

          getMembershipLevelInfoForTicketDiscount: function(eventId, ticketTypeId) {
            var i, ii,
                price,
                discountValue,
                r = '';
            if (this.memberDiscountedPriceMap.hasOwnProperty(eventId) &&
                this.memberDiscountedPriceMap[eventId] instanceof Array &&
                this.memberDiscountedPriceMap[eventId].length) {

              for (i=0, ii=this.memberDiscountedPriceMap[eventId].length; i < ii; i++) {
                if (this.memberDiscountedPriceMap[eventId][i].prices.hasOwnProperty(ticketTypeId)) {
                  price = this.memberDiscountedPriceMap[eventId][i].prices[ticketTypeId];
                  if (price.hasOwnProperty('discountValue')) {
                    discountValue = HelpersService.currencyFloatToInteger(price.discountValue);
                    if (discountValue > 0) {
                      r = this.memberDiscountedPriceMap[eventId][i].membershipLevelCollectionName || '';
                      r = (r ? r + ' - ' : '') + this.memberDiscountedPriceMap[eventId][i].membershipLevelName;
                      break;
                    }
                  }
                }
              }

            }
            return r;
          },

          getRetailPriceForTicketDiscount: function(eventId, ticketTypeId) {
            var i, ii,
                price,
                retailPrice,
                r = '';
            if (this.memberDiscountedPriceMap.hasOwnProperty(eventId) &&
                this.memberDiscountedPriceMap[eventId] instanceof Array &&
                this.memberDiscountedPriceMap[eventId].length) {

              for (i=0, ii=this.memberDiscountedPriceMap[eventId].length; i < ii; i++) {
                if (this.memberDiscountedPriceMap[eventId][i].prices.hasOwnProperty(ticketTypeId)) {
                  price = this.memberDiscountedPriceMap[eventId][i].prices[ticketTypeId];
                  if (price.hasOwnProperty('discountValue')) {
                    retailPrice = HelpersService.currencyFloatToInteger(price.price);
                    if (retailPrice > 0) {
                      r = HelpersService.integerToCurrencyFloat(retailPrice);
                      break;
                    }
                  }
                }
              }

            }
            return r;
          },

          selectHour: function(hour) {

            if (!this.isSoldOutTime(hour)) {
              if (!(this.model.priceLists instanceof Array) || !this.model.priceLists[0]) {
                this.model.priceLists = [ { prices: [] } ];
              }
              this.model.name = hour.event.name;
              this.model.priceLists[0].prices = this.updateSelectedEventPrices(hour.event.priceList);
              this.selectedHour = this.getSlotTime(hour.time);
              this.selectedHourId = hour.id;

              this.model.selectedHourId = hour.id;
              this.model.orderForms = hour.event.orderForms;
              this.selectedHourAvailableSeats = hour.availableSeats;
              this.remainingSeats = hour.availableSeats;

              $state.transitionTo($state.current.name, Object.assign($state.params, { date: hour.startTime }), {
                location: true,
                reload: false,
              });

              // The event instance changed, so reset limits
              SalesRuleService.resetLimits();
              this.onOrdersUpdatedLimits();

              $timeout(function() {
                $scope.$broadcast('Event::selectHour');
                $scope.$emit('Event::HourUpdate', { event: $scope.event.model });
              }, 10);

              console.log('Event::selectHour', this.selectedHourAvailableSeats);
            }
          },

          selectComboHour: function(hour, eventTemplateId) {

            var comboEventIndex = this.findComboEvent(eventTemplateId).index,
                self = $scope.event;

            if (!self.isSoldOutTime(hour)) {
              if (!(self.comboEvents[comboEventIndex].priceLists instanceof Array) || self.comboEvents[comboEventIndex].priceLists[0]) {
                self.comboEvents[comboEventIndex].priceLists[0].prices = [ { prices: [] } ];
              }
              self.comboEvents[comboEventIndex].name = hour.event.name;
              self.comboEvents[comboEventIndex].priceLists[0].prices = self.updateSelectedEventPrices(hour.event.priceList);
              self.comboEvents[comboEventIndex].selectedHour = self.getSlotTime(hour.time);
              self.comboEvents[comboEventIndex].selectedHourId = hour.id;


              self.comboEvents[comboEventIndex].selectedHourAvailableSeats = hour.availableSeats;
              self.comboEvents[comboEventIndex].remainingSeats = hour.availableSeats - self.ticketTotalQuantity;
              self.comboEvents[comboEventIndex].orderForms = hour.event.orderForms;
              self.remainingSeats = 100;

              $timeout(function() {
                $scope.$broadcast('Event::selectComboHour', { hourId: hour.id, eventTemplateId: eventTemplateId });
                $scope.$emit('Event::ComboHourUpdate', {
                  hourId: hour.id,
                  eventTemplateId: eventTemplateId,
                  event: self.comboEvents[comboEventIndex]
                });
              }, 10);

              console.log('Event::selectComboHour', self.comboEvents[comboEventIndex].selectedHourId);
            }
          },

          chooseHour: function(hour, updateCart) {
            var h;

            if (hour !== false) {
              this.isAtCapacity = false;

              if (!this.model.selectedHourId || this.isTimeFromURL) {
                this.selectHour(hour);
                return; // Prevent duplicate Event::HourUpdate
              } else {
                h = this.getHour(this.model.selectedHourId);

                if (!(this.model.priceLists instanceof Array) || !this.model.priceLists[0]) {
                  this.model.priceLists = [ { prices: [] } ];
                }

                this.model.name = h.event.name;
                this.model.priceLists[0].prices = this.updateSelectedEventPrices(h.event.priceList);
                this.model.orderForms = h.event.orderForms;
                this.selectedHour = this.getSlotTime(h.time);
                this.selectedHourId = h.id;
                this.selectedHourAvailableSeats = h.availableSeats;
                this.remainingSeats = h.availableSeats;

                console.log('Event::chooseHour', this.selectedHourAvailableSeats);
              }

              this.onOrdersUpdatedLimits();
              this.updateRemaining();
              this.updateTotal();

            }else{
              this.isAtCapacity = true;
            }

            if (updateCart) {
              $scope.$emit('Event::HourUpdate', { event: this.model });
            }
          },

          chooseComboHour: function(hour, event) {
            var h;

            if (hour !== false) {
              event.isAtCapacity = false;

              if (!event.selectedHourId) {
                this.selectComboHour(hour, event.id);
                return; // Prevent duplicate Event::ComboHourUpdate
              } else {
                h = this.getComboHour(event.selectedHourId, event);

                event.name = h.event.name;
                event.priceLists[0].prices = this.updateSelectedEventPrices(h.event.priceList);
                event.selectedHour = this.getSlotTime(h.time);
                event.selectedHourId = h.id;
                event.selectedHourAvailableSeats = h.availableSeats;
                event.remainingSeats = h.availableSeats;

                console.log('Event::chooseComboHour', {
                  hourId: h.id,
                  comboId: this.model.id,
                  eventTemplateId: event.id,
                  selectedHourAvailableSeats: event.selectedHourAvailableSeats
                });
              }

              this.updateComboRemaining(event);
              this.updateTotal();

            }else{
              event.isAtCapacity = true;
            }


            $scope.$emit('Event::ComboHourUpdate', {
              comboId: this.model.id,
              eventTemplateId: event.id
            });

          },

          showPrerequisites: function() {
            var r = false;
            if (EventsService.hasPrerequisites(this.model) && !this.isMode('view')) {
              this.prerequisite = EventsService.getPrerequisiteEvent(this.model);
              r = true;
            }
            return r;
          },

          checkGAPrerequisite: function() {
            if (this.GA && $scope.gaExists) {
              this.disabledActions.push('requires');
            }else if (!this.isMode('carted')) {
              this.enableAction('requires');
            }
          },

          checkPrerequisites: function() {
            console.log('Event::checkPrerequisites', this.model);
            if (OrderService.eventItemPrerequisitesMet(this.model)) {
              this.disabledActions.push('requires');
            }else if (!this.isMode('carted')) {
              this.enableAction('requires');
            }
          },

          showEventMeta: function() {
            console.log('Event::showEventMeta', this.isGA);
            return ((!this.isGA && !(this.isEventType('combo') && this.isMode('added'))) || this.isMode('view'));
          },

          getPrice: function() {
            let value: string = '0';
            let price: string | false = false;

            try {
              value = this.model.priceLists[0].prices[0].price;
              price = '$' + value;
              if (parseInt(value, 10) <= 0) {
                price = 'No charge';
              } else {
                if (value.toString().indexOf('.') !== -1) {
                  price = '$' + parseFloat(value).toFixed(2);
                }
              }

              console.log('Event::getPrice', price, parseInt(value, 10) );
            }catch(e) {
              price = false;
            }

            return price;
          },

          getDiscountedTotal: function() {
            return HelpersService.integerToCurrencyFloat(HelpersService.currencyFloatToInteger(this.ticketTotal) + HelpersService.currencyFloatToInteger(this.ticketRetailTotal) - HelpersService.currencyFloatToInteger(this.model.discountTotal));
          },

          getFullPriceSubTotal: function() {
            return HelpersService.integerToCurrencyFloat(HelpersService.currencyFloatToInteger(this.ticketTotal) + HelpersService.currencyFloatToInteger(this.ticketRetailTotal) - HelpersService.currencyFloatToInteger(this.ticketAddonTotal) );
          },

          getAddonSubTotal: function() {
            return HelpersService.integerToCurrencyFloat(HelpersService.currencyFloatToInteger(this.ticketAddonTotal) );
          },

          getRetailSubTotal: function() {
            return HelpersService.integerToCurrencyFloat(HelpersService.currencyFloatToInteger(this.ticketRetailTotal) );
          },

          isTicketTypeInEvents: function(id) {
            var i, ii,
                j, jj,
                r = false;

            for (i = 0, ii = this.comboEvents.length; i < ii; i++) {
              for (j = 0, jj = this.comboEvents[i].priceLists[0].prices.length; j < jj; j++) {
                if (this.comboEvents[i].priceLists[0].prices[j].personType.id === id) {
                  r = true;
                  break;
                }
              }
            }

            return r;
          },

          updateSelectedEventPrices: function(priceList) {
            var i, ii;
            var j, jj;
            var k, kk;
            var entry;
            var _last: TODO[] = [];
            var _next: TODO[] = [];

            if (priceList && priceList.prices instanceof Array) {
              _next = angular.copy(priceList.prices);

              if (this.model.type === 'discountCode') {
                // Apply discount code to each ticket purchased
                for (j=0,jj=this.comboEvents.length;j<jj;j++) {
                  entry = this.comboEvents[j];
                  entry.ticketTotalQuantity = 0;
                  for (i=0,ii=this.model.discount.values.length;i<ii;i++) {
                    for (k = 0, kk = _next.length; k < kk; k++) {
                      if (_next[k].personType.id === this.model.discount.values[i].personType.id) {
                        _next[k].quantity = this.model.discount.values[i].quantity;
                        if (this.isDiscountDistributionType('each')) {
                          _next[k].discountedPrice = DiscountService.applyDiscount(this.model.discount.values[i], _next[k].price);
                        }else{
                          _next[k].discountedPrice = _next[k].price;
                        }
                        _next[k].total = _next[k].discountedPrice * this.model.discount.values[i].quantity;
                        entry.ticketTotalQuantity += +_next[k].quantity;
                        break;
                      }
                    }
                  }
                }
              }
            }

            if (this.model.priceLists instanceof Array &&
                this.model.priceLists[0] &&
                this.model.priceLists[0].prices instanceof Array) {
              _last = angular.copy(this.model.priceLists[0].prices);
              if (this.model.cartedPrices instanceof Array && this.model.cartedPrices.length) {
                _last = _last.concat(angular.copy(this.model.cartedPrices));
              }
            }

            for (i=0,ii=_next.length;i<ii;i++) {
              for (j=0,jj=_last.length;j<jj;j++) {
                if (_next[i].personType.id === _last[j].personType.id) {
                  if (_last[j].retailQuantity) {
                    _next[i].retailQuantity = _last[j].retailQuantity;
                    _next[i].showRetailPrice = true;
                  }
                  if (_last[j].quantity) {
                    _next[i].quantity = _last[j].quantity;
                  }
                  break;
                }
              }
            }

            return _next;
          },

          updateTotal: function() {

            var i, ii;
            var j, jj;
            var k, kk;
            var entry;
            var personTypeId;
            var ticketTotalQuantity;
            var ticketRetailTotalQuantity;
            var prices: TODO[] = [];
            var inventoryAddOns: TODO[] = [];

            if (this.hasAddOns()) {
              if (this.isEventType('combo')) {
                inventoryAddOns = this.model.addOns;
              }else{
                inventoryAddOns = this.model.addOns.inventoryAddOns;
              }
            }

            if (this.model.hasOwnProperty('priceLists') &&
                this.model.priceLists instanceof Array &&
                this.model.priceLists[0]) {
              prices = this.model.priceLists[0].prices;
              this.hasPrices = true;
            }else if (this.model.type === 'fixedPrice') {
              prices = this.model.priceList.prices;
              this.hasPrices = true;
            }else if (this.model.type === 'discountCode') {
              // Apply discount code to each ticket purchased
              for (j=0,jj=this.comboEvents.length;j<jj;j++) {
                entry = this.comboEvents[j];
                entry.ticketTotalQuantity = 0;
                for (i=0,ii=this.model.discount.values.length;i<ii;i++) {
                  for (k = 0, kk = entry.priceLists[0].prices.length; k < kk; k++) {
                    if (entry.priceLists[0].prices[k].personType.id === this.model.discount.values[i].personType.id) {
                      entry.priceLists[0].prices[k].quantity = this.model.discount.values[i].quantity;
                      if (this.isDiscountDistributionType('each')) {
                        entry.priceLists[0].prices[k].discountedPrice = DiscountService.applyDiscount(this.model.discount.values[i], entry.priceLists[0].prices[k].price);
                      }else{
                        entry.priceLists[0].prices[k].discountedPrice = entry.priceLists[0].prices[k].price;
                      }
                      entry.priceLists[0].prices[k].total = entry.priceLists[0].prices[k].discountedPrice * this.model.discount.values[i].quantity;
                      entry.ticketTotalQuantity += +entry.priceLists[0].prices[k].quantity;
                      break;
                    }
                  }
                }
              }
              for (i=0,ii=this.comboEvents.length;i<ii;i++) {
                entry = this.comboEvents[i];
                if (entry) {
                  prices = prices.concat(entry.priceLists[0].prices);
                }
              }
              this.hasPrices = true;
            }else {
              this.hasPrices = false;
            }

            console.log('Event::updateTotal -> priceLists', this.hasPrices, prices);

            this.ticketTotal = 0;
            this.ticketRetailTotal = 0;
            this.ticketAddonTotal = 0;
            this.ticketTotalQuantity = 0;
            this.ticketRetailTotalQuantity = 0;
            this.discountTotal = 0;
            this.discountQuantities = {};

            for (i=0,ii=prices.length;i<ii;i++) {
              if (prices[i].total) {
                this.ticketTotal += +prices[i].total;
              }

              if (prices[i].quantity) {
                ticketTotalQuantity = +prices[i].quantity * OrderService.getTicketMultiplier(prices[i]);
                this.ticketTotalQuantity += ticketTotalQuantity;
                // Gather total quantities per ticket type to apply discount only once per ticket per type
                if (!this.discountQuantities[prices[i].personType.id]) {
                  this.discountQuantities[prices[i].personType.id] = {
                    quantity: 0,
                    price: prices[i].price
                  };
                }
                this.discountQuantities[prices[i].personType.id].quantity += ticketTotalQuantity;
              }

              if (prices[i].retailTotal) {
                this.ticketRetailTotal += +prices[i].retailTotal;
              }
              if (prices[i].retailQuantity) {
                ticketRetailTotalQuantity = +prices[i].retailQuantity * OrderService.getTicketMultiplier(prices[i]);
                this.ticketRetailTotalQuantity += ticketRetailTotalQuantity;
                this.ticketTotalQuantity += ticketRetailTotalQuantity;
              }
            }

            console.log('Event::updateTotal -> priceLists', this.ticketTotal, this.ticketTotalQuantity);

            // Only apply a single discount per ticket per type
            if (this.hasTotalAmountDiscount()) {
              for (personTypeId in this.discountQuantities) {
                if (this.discountQuantities.hasOwnProperty(personTypeId)) {
                  for (j = 0, jj = this.model.discount.values.length; j < jj; j++) {
                    if (personTypeId === this.model.discount.values[j].personType.id) {
                      this.discountTotal += DiscountService.applyTotalDiscount(this.model.discount.values[j], this.discountQuantities[personTypeId].quantity, this.discountQuantities[personTypeId].price);
                      break;
                    }
                  }
                }
              }
            }

            this.model.discountTotal = this.discountTotal;

            for (i=0,ii=inventoryAddOns.length;i<ii;i++) {
              if (inventoryAddOns[i].total) {
                console.log('Event::updateTotal -> inventoryAddOns', inventoryAddOns[i].total);
                this.ticketTotal += +inventoryAddOns[i].total;
                this.ticketAddonTotal += +inventoryAddOns[i].total;
              }
            }

            console.log(this.ticketTotal, prices);
            console.log(this.ticketRetailTotal, prices);

            if (this.isEventType('combo')) {
              for (i=0,ii=this.comboEvents.length;i<ii;i++) {
                if (this.model.type === 'discountCode') {
                  this.updateDiscountComboRemaining(this.comboEvents[i]);
                }else{
                  this.updateComboRemaining(this.comboEvents[i]);
                }
              }
            }else{
              this.updateRemaining();
            }

            console.log('Event::updateTotal', this.remainingSeats, this.selectedHourAvailableSeats);

            $scope.$emit('Event::UpdateTotal');

          },

          updateRemaining: function() {
            this.remainingSeats = this.selectedHourAvailableSeats - this.ticketTotalQuantity;
            $scope.remaining = this.remainingSeats;
            this.checkMaxed();
          },

          updateComboRemaining: function(event) {

            event.remainingSeats = event.selectedHourAvailableSeats - this.ticketTotalQuantity;
            console.log('Event::updateComboRemaining', event.remainingSeats, event.selectedHourAvailableSeats, this.ticketTotalQuantity);

            this.checkComboEventMaxed(event);
            $scope.remaining = this.remainingSeats;
          },

          updateDiscountComboRemaining: function(event) {

            event.remainingSeats = event.selectedHourAvailableSeats - event.ticketTotalQuantity;
            console.log('Event::updateDiscountComboRemaining', event, event.remainingSeats, event.selectedHourAvailableSeats, event.ticketTotalQuantity);

            this.checkDiscountComboEventMaxed(event);
            $scope.remaining = this.remainingSeats;
          },


          autoSelect: function() {
            var h;
            var m;
            var t;
            var index = 0;
            var updateCart = true;

            for (let i = 0, ii = this.hours.length; i < ii; i++) {
              t = EventsService.getSlotTime(this.hours[i].time);
              h = parseInt(t, 10);
              m = parseInt(t.split(':')[1], 10);

              if (h >= 9 && m >= 35 && !this.isSoldOutTime(this.hours[i])) {
                index = i;
                break;
              }
            }

            this.hours.splice(0, index);
            this.chooseHour(this.hours[0], updateCart);

            this.moreHours = this.hours.splice(this.autoSelectSlots, 9999);
          },

          hasMemberLimitErrors: function(prices, memberTicketLimitMap) {
            var r = false;

            prices.forEach(function(ticket) {
              if (
                ( memberTicketLimitMap[ticket.personType.id]['regular'].limit !== null || memberTicketLimitMap[ticket.personType.id]['retail'].limit !== null) &&
                (
                  ( memberTicketLimitMap[ticket.personType.id]['regular'].ruleType !== null && memberTicketLimitMap[ticket.personType.id]['regular'].ruleType.name !== 'eventSales' ) ||
                  ( memberTicketLimitMap[ticket.personType.id]['retail'].ruleType !== null && memberTicketLimitMap[ticket.personType.id]['retail'].ruleType.name !== 'eventSales' )
                )
              ) {
                r = true;
              }
            });

            return r;
          },

          hasEventSalesLimitErrors: function(prices, memberTicketLimitMap) {
            var r = false;

            prices.forEach(function(ticket) {
              if (
                ( memberTicketLimitMap[ticket.personType.id]['regular'].limit !== null || memberTicketLimitMap[ticket.personType.id]['retail'].limit !== null ) &&
                (
                  ( memberTicketLimitMap[ticket.personType.id]['regular'].ruleType !== null && memberTicketLimitMap[ticket.personType.id]['regular'].ruleType.name === 'eventSales' ) ||
                  ( memberTicketLimitMap[ticket.personType.id]['retail'].ruleType !== null && memberTicketLimitMap[ticket.personType.id]['retail'].ruleType.name === 'eventSales' )
                )
              ) {
                r = true;
              }
            });

            return r;
          },

          hasMemberGroupLimitErrors: function(memberGroupLimitMap) {
            var r = false;

            angular.forEach(memberGroupLimitMap['regular'], function(regularGroupLimit) {
              if (regularGroupLimit.limit !== null && regularGroupLimit.ruleType.name !== 'eventSales') {
                r = true;
              }
            });

            angular.forEach(memberGroupLimitMap['retail'], function(regularGroupLimit) {
              if (regularGroupLimit.limit !== null && regularGroupLimit.ruleType.name !== 'eventSales') {
                r = true;
              }
            });

            return r;
          },

          hasMemberTicketLimitErrors: function(memberGroupLimitMap) {
            var r = false;

            angular.forEach(memberGroupLimitMap['regular'], function(regularGroupLimit) {
              if (regularGroupLimit.limit !== null && regularGroupLimit.ruleType.name === 'eventSales') {
                r = true;
              }
            });

            angular.forEach(memberGroupLimitMap['retail'], function(regularGroupLimit) {
              if (regularGroupLimit.limit !== null && regularGroupLimit.ruleType.name === 'eventSales') {
                r = true;
              }
            });

            return r;
          },

          checkLimitExceeded: function(ticket, eventId, isRetail) {
            var quantity = isRetail ? ticket.retailQuantity : ticket.quantity;
            var retailAndDiscountedTicketQuantity = parseInt(ticket.retailQuantity || 0, 10) + parseInt(ticket.quantity || 0, 10);
            var type = isRetail ? 'retail' : 'regular';
            var r = false;
            var isMemberPerTicketLimit = (
                this.memberTicketLimitMap[ticket.personType.id] &&
                this.memberTicketLimitMap[ticket.personType.id][type] &&
                this.memberTicketLimitMap[ticket.personType.id][type].limit &&
                (
                  !this.memberTicketLimitMap[ticket.personType.id][type].ruleType ||
                  this.memberTicketLimitMap[ticket.personType.id][type].ruleType.name !== 'eventSales'
                )
              );

            var perTicketLimit = (
                this.memberTicketLimitMap[ticket.personType.id] &&
                this.memberTicketLimitMap[ticket.personType.id][type] &&
                this.memberTicketLimitMap[ticket.personType.id][type].remaining !== null &&
                (isMemberPerTicketLimit ? (quantity > this.memberTicketLimitMap[ticket.personType.id][type].remaining) : (retailAndDiscountedTicketQuantity > this.memberTicketLimitMap[ticket.personType.id][type].remaining))
              );

            var groupLimit = false;
            var isGroupMemberLimit = false;
            var groups: TODO[] = [];
            var i, ii;

            ticket.groupQuantity = retailAndDiscountedTicketQuantity;

            if (this.ticketLimitGroups[ticket.personType.id] &&
              this.ticketLimitGroups[ticket.personType.id][type] &&
              this.ticketLimitGroups[ticket.personType.id][type].groups instanceof Array) {
              groups = this.ticketLimitGroups[ticket.personType.id][type].groups;

              for (i=0, ii=groups.length; i < ii; i++) {
                if (
                  groups[i].groupMax !== null &&
                  groups[i].groupQuantity !== null
                ) {

                  // regular limit rule
                  if (
                    !groups[i].isPreventRule &&
                    (groups[i].groupQuantity > groups[i].groupMax)
                  ) {
                    groupLimit = true;
                    isGroupMemberLimit = (!groups[i].ruleType || groups[i].ruleType.name !== 'eventSales');
                    break;
                  }

                  // prevent rule
                  if (
                    groups[i].isPreventRule &&
                    (
                      (
                        groups[i].inCartLimit &&
                        groups[i].groupQuantity > groups[i].groupMax &&
                        groups[i].preventGroupQuantity > 0
                      ) ||
                      (
                        !groups[i].inCartLimit &&
                        groups[i].preventGroupQuantity > 0
                      )
                    )
                  ) {
                    groupLimit = true;
                    isGroupMemberLimit = (!groups[i].ruleType || groups[i].ruleType.name !== 'eventSales');
                    break;
                  }
                }
              }
            }

            r = perTicketLimit || groupLimit;

            if (r && (isMemberPerTicketLimit || isGroupMemberLimit)) {
              ticket.showRetailPrice = this.hasDiscountPrice(ticket, eventId) && true;
            }
            return r;
          },

          checkLimitErrors: function() {
            let result = false;
            let regularLimitExceeded;
            let retailLimitExceeded;

            if (this.model.priceLists instanceof Array && this.model.priceLists.length &&
              this.model.priceLists[0].prices instanceof Array) {
              for (let i = 0, ii = this.model.priceLists[0].prices.length; i < ii; i++) {
                regularLimitExceeded = this.checkLimitExceeded(this.model.priceLists[0].prices[i], this.selectedHourId, false);
                retailLimitExceeded = this.checkLimitExceeded(this.model.priceLists[0].prices[i], this.selectedHourId, true);
                if (!result) {
                  result = regularLimitExceeded || retailLimitExceeded;
                }
              }
            }

            $scope.$emit('Event::checkLimitErrors', { hasLimitErrors: result });

            return result;
          },

          computeGroupTicketLimits: function() {
            var self = $scope.event,
              ticketTypeIds = [],
              groups;

            // reset all ticket type group limits
            this.setMemberTicketLimitGroups(this.ticketLimitGroups, null, false);
            this.setMemberTicketLimitGroups(this.ticketLimitGroups, null, true);

            if (this.memberGroupLimitMap.hasOwnProperty('regular')) {
              groups = this.memberGroupLimitMap.regular;
              //get quantities for prices in the limit
              angular.forEach(groups, function(group) {
                var groupQuantity = 0,
                    preventGroupQuantity = 0;

                ticketTypeIds = group.groupId.split('-');
                if (!group.ruleType || group.ruleType.name === 'memberBenefits') {
                  groupQuantity = self.getQuantityForTicketTypes(ticketTypeIds, false);
                } else {
                  groupQuantity = self.getQuantityForTicketTypes(ticketTypeIds, false, group);
                  groupQuantity = groupQuantity + self.getQuantityForTicketTypes(ticketTypeIds, true, group);

                  preventGroupQuantity = self.getQuantityForPreventTicketTypes(ticketTypeIds, false, group);
                  preventGroupQuantity = preventGroupQuantity + self.getQuantityForPreventTicketTypes(ticketTypeIds, true, group);
                }
                angular.forEach(ticketTypeIds, function(ticketTypeId) {
                  if (self.ticketLimitGroups[ticketTypeId]) {
                    self.ticketLimitGroups[ticketTypeId]['regular'].groups.push({
                      groupMax: group.remaining,
                      groupQuantity: groupQuantity,
                      preventGroupQuantity: preventGroupQuantity,
                      groupId: group.groupId,
                      ticketTypes: group.groupId.split('-'),
                      ruleType: group.ruleType,
                      isPreventRule: group.isPreventRule,
                      inCartLimit: group.inCartLimit
                    });
                  }
                });

              });
            }

            if (this.memberGroupLimitMap.hasOwnProperty('retail')) {
              groups = this.memberGroupLimitMap.retail;
              //get quantities for prices in the limit
              angular.forEach(groups, function(group) {
                var groupQuantity;

                ticketTypeIds = group.groupId.split('-');

                groupQuantity = self.getQuantityForTicketTypes(ticketTypeIds, true);

                angular.forEach(ticketTypeIds, function(ticketTypeId) {
                  if (self.ticketLimitGroups[ticketTypeId]) {
                    self.ticketLimitGroups[ticketTypeId]['retail'].groups.push({
                      groupMax: group.remaining,
                      groupQuantity: groupQuantity,
                      groupId: group.groupId,
                      ruleType: group.ruleType,
                      isPreventRule: group.isPreventRule,
                      inCartLimit: group.inCartLimit
                    });
                  }
                });

              });
            }

          },

          getTicketMax: function (ticket, group) {
            var result = 0;
            var self = $scope.event;
            var tests = SalesRuleService.getTestResults();
            var currentMax = {};
            var ticketTypeId = ticket.personType.id;
            var prices = this.model.priceLists[0].prices;

            if (!group.isPreventRule) {
              result = group.group.remaining;
              angular.forEach(group.ticketTypes, function(ticketId){
                if (ticket.personType.id !== ticketId) {
                  angular.forEach(prices, function(price) {
                    if (price.personType.id === ticketId) {
                      result -= price.quantity;
                    }
                  });
                }
              });
              if (result < 0) {
                result = 0;
              }
            } else {
              angular.forEach(tests, function(test) {
                if (
                  test.ruleType === 'EVENT_SALES' &&
                  self.findInArray(test.pricepointIds, ticketTypeId)
                ) {
                  if (!currentMax.hasOwnProperty(ticketTypeId) && !test.validatedPricePointIds.length) {
                      currentMax[ticketTypeId] = test.allowedQuantity;
                  } else {
                    if ( test.validatedPricePointIds.length ) {
                      angular.forEach(prices, function(price) {
                        if (
                          price.quantity > 0 &&
                          self.findInArray(test.validatedPricePointIds, price.personType.id) &&
                          price.quantity >= 1
                        ) {
                          if (!currentMax.hasOwnProperty(ticketTypeId)) {
                            currentMax[ticketTypeId] = test.allowedQuantity;
                          }

                          if ( currentMax[ticketTypeId] > test.allowedQuantity ) {
                            currentMax[ticketTypeId] = test.allowedQuantity;
                          }
                        }
                      });
                    }
                  }
                  result = ( currentMax.hasOwnProperty(ticketTypeId) ) ? currentMax[ticketTypeId] : self.selectedHourAvailableSeats;
                }

                if (
                  test.ruleType === 'EVENT_SALES' && 
                  test.validatedPricePointIds.length &&
                  self.findInArray(test.validatedPricePointIds, ticketTypeId)
                ) {
                  angular.forEach(prices, function(price) {
                    if (
                      price.quantity > 0 &&
                      self.findInArray(test.pricepointIds, price.personType.id) &&
                      price.quantity > test.allowedQuantity
                    ) {
                      currentMax[ticketTypeId] = 0;
                    }
                  });
                  result = ( currentMax.hasOwnProperty(ticketTypeId) ) ? currentMax[ticketTypeId] : 100;
                }
              });
            }

            return result;
          },

          findInArray: function(arr, id) {
            var r = null;
            angular.forEach(arr, function(el) {
              if (el === id) {
                r = id;
              }
            });
            return r;
          },

          setMemberTicketLimitGroups: function(memberTicketLimitMap, limitMap, isRetail) {
            var key = isRetail ? 'retail' : 'regular';

            if (this.model.priceLists instanceof Array && this.model.priceLists.length &&
              this.model.priceLists[0].prices instanceof Array) {
              angular.forEach(this.model.priceLists[0].prices, function(ticket) {
                if (!memberTicketLimitMap[ticket.personType.id]) {
                  memberTicketLimitMap[ticket.personType.id] = {
                    regular: {},
                    retail: {}
                  };
                }
                if (!memberTicketLimitMap[ticket.personType.id][key]) {
                  memberTicketLimitMap[ticket.personType.id][key] = {};
                }

                if (limitMap && limitMap[ticket.personType.id] && limitMap[ticket.personType.id][key] &&
                  (limitMap[ticket.personType.id][key].groups instanceof Array)) {
                  memberTicketLimitMap[ticket.personType.id][key].groups = limitMap[ticket.personType.id][key].groups;
                } else {
                  memberTicketLimitMap[ticket.personType.id][key].groups = [];
                }
              });
            }
          },

          getQuantityForTicketTypes: function(ticketTypeIds, isRetail, group) {
            var quantity = 0;

            if (this.model.priceLists instanceof Array && this.model.priceLists.length &&
              this.model.priceLists[0].prices instanceof Array) {

              angular.forEach(ticketTypeIds, function(ticketTypeId) {
                var self = $scope.event;
                var r: string | number = 0;

                var found = self.model.priceLists[0].prices.filter(function(ticket) {
                  var retail = (!!ticket.isRetail || !!ticket.retailQuantity) && true;
                  return (ticket.personType.id === ticketTypeId &&
                  (!isRetail || (retail === isRetail)));
                });

                if (found && found.length) {
                  r = isRetail ? found[0].retailQuantity : found[0].quantity;

                  // calculate group quantity for prevents
                  if (group && group.isPreventRule) {
                    if (
                      found[0].personType.id !== group.violation.ticketTypeId &&
                      group.violation.ticketTypeIds.indexOf(found[0].personType.id) < 0
                    ) {
                      r = 0;
                    }
                  }

                  r = typeof r === 'string' ? parseInt(r, 10) : r;

                  if (isNaN(r)) {
                    r = 0;
                  }
                }

                quantity += r;
              });
            }

            return quantity;
          },

          getQuantityForPreventTicketTypes: function(ticketTypeIds, isRetail, group) {
            var found: TODO[] = [];
            var quantity = 0;

            if (this.model.priceLists instanceof Array && this.model.priceLists.length &&
              this.model.priceLists[0].prices instanceof Array) {

              angular.forEach(ticketTypeIds, function(ticketTypeId) {
                var self = $scope.event,
                  r = 0;

                found = self.model.priceLists[0].prices.filter(function(ticket) {
                  var retail = (!!ticket.isRetail || !!ticket.retailQuantity) && true;
                  return (ticket.personType.id === ticketTypeId &&
                  (!isRetail || (retail === isRetail)));
                });

                if (found && found.length) {
                  r = isRetail ? found[0].retailQuantity : found[0].quantity;

                  // calculate group quantity for prevented
                  if (group && group.isPreventRule) {
                    if (
                      found[0].personType.id === group.violation.ticketTypeId ||
                      group.violation.ticketTypeIds.indexOf(found[0].personType.id) >= 0
                    ) {
                      r = 0;
                    }
                  }
                  r = typeof r === 'string' ? parseInt(r, 10) : r;
                  if (isNaN(r)) {
                    r = 0;
                  }
                }

                quantity += r;
              });
            }

            return quantity;
          },

          checkMaxed: function() {
            console.log('Event::checkMaxed', $scope.remaining);
            this.isMaxed = ($scope.remaining < 0);
            $scope.$emit('Event::checkMaxed', {isMaxed: this.isMaxed});
          },

          checkComboEventMaxed: function(event) {
            event.remainingSeats = event.selectedHourAvailableSeats - this.ticketTotalQuantity;

            if (event) {
              console.log('Event::checkComboEventMaxed', event, event.remainingSeats, this.ticketTotalQuantity);
              event.isMaxed = (event.remainingSeats < 0);
              $scope.$emit('Event::checkComboEventMaxed');
            }
          },

          checkDiscountComboEventMaxed: function(event) {
            event.remainingSeats = event.selectedHourAvailableSeats - event.ticketTotalQuantity;

            if (event) {
              console.log('Event::checkDiscountComboEventMaxed', event, event.remainingSeats, event.ticketTotalQuantity);
              event.isMaxed = (event.remainingSeats < 0);
              $scope.$emit('Event::checkComboEventMaxed');
            }
          },

          showMore: function() {
            if (this.moreHours.length > 0) {
              this.hours.push.apply(this.hours, this.moreHours.splice(0, this.autoSelectSlots));
            }
          },

          getEventDate: function(event) {

            var r = $scope.startTime;

            if (event && event.selectedDate) {
              r = event.selectedDate;
            }

            return r;
          },

          getHours: function() {
            var orig = this.getEventDate(this.model),
                d = CalendarService.getParsableDate(orig),
                startTime =  CalendarService.toISO8601(d),
                endTime = CalendarService.toISO8601(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 0, 0)),
                membershipIds = (this.model.membershipCategoryId) ? this.membershipIdsWithoutGracePeriod : this.membershipIds;

            if (this.hours.length === 0) {
              EventsService.api.times({
                tenantId: this.tenantId,
                membershipId: membershipIds ? membershipIds : null,
                membershipCategoryId: this.model.membershipCategoryId || null,
                eventTemplateId: this.model.id,
                startTime: startTime,
                endTime: endTime,
                saleChannel: 'online'
              }).then(this.success.getHours, this.error.getHours);
            } else {
              this.error.getHours();
            }
          },

          getDiscountedPricesForMember: function() {
            var orig = this.getEventDate(this.model),
              d = CalendarService.getParsableDate(orig),
              startTime =  CalendarService.toISO8601(d),
              endTime = CalendarService.toISO8601(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 0, 0)),
              membershipId = (this.model.membershipCategoryId) ? this.membershipIdsWithoutGracePeriod : this.membershipIds;


            EventsService.api.pricing({
              tenantId: this.tenantId,
              membershipIds: membershipId ? membershipId.split(',') : null,
              membershipLevelIds: this.model.membershipCategoryId ? this.model.membershipCategoryId.split(',') : null,
              eventTemplateId: this.model.id,
              eventStartTime: startTime,
              eventEndTime: endTime,
              saleChannel: 'online'
            }).then(this.success.getDiscountedPricesForMember, this.error.getDiscountedPricesForMember);
          },

          getComboHours: function(eventTemplateId, comboTemplateId, membershipIds) {
            var self = $scope.event,
                comboEvent = self.findComboEvent(eventTemplateId).event,
                orig = this.getEventDate(comboEvent),
                d = CalendarService.getParsableDate(orig),
                startTime =  CalendarService.toISO8601(d),
                endTime = CalendarService.toISO8601(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 0, 0));

            console.log('Event::getComboHours', comboEvent, eventTemplateId, comboTemplateId, orig);

            if (this.hours.length === 0) {
              EventsService.api.times({
                tenantId: this.tenantId,
                membershipId: membershipIds || null,
                membershipCategoryId: this.model.membershipCategoryId || null,
                eventTemplateId: eventTemplateId,
                comboTemplateId: comboTemplateId,
                startTime: startTime,
                endTime: endTime,
                saleChannel: 'online'
              }).then(function(response) {

                comboEvent.hours = response.data.payload;

                // Auto select if there is only one showing
                if (comboEvent.hours) {
                  comboEvent.showHours = (comboEvent.hours.length > 1);
                  self.chooseComboHour(self.getFirstAvailableTime(comboEvent.hours), comboEvent);
                }
                self.isLoaded = true;
                self.success.getComboHours(response);
              }, function(response) {
                self.isLoaded = true;
                self.error.getComboHours(response);
              });
            }

          },

          getFirstAvailableTime: function(hours) {
            var result: TODO | false = false;
            var modelDate = CalendarService.getParsableDate(this.getEventDate(this.model));
            var currentDate: Date | false = false;

            for (let i = 0, ii = hours.length; i <ii; i++) {
              currentDate = CalendarService.getParsableDate(hours[i].startTime);

              if (!this.isSoldOutTime(hours[i]) && !result) {
                result = hours[i];
              }

              if (currentDate !== false && currentDate.toTimeString() === modelDate.toTimeString()) {
                result = hours[i];
                this.isTimeFromURL = true;
              }
            }

            console.log('Event::getFirstAvailableTime', result);
            return result;
          },

          getTicketsForLimits: function() {
            var tickets = [];

            if (this.model.priceLists instanceof Array && this.model.priceLists.length &&
              this.model.priceLists[0].prices instanceof Array) {
              tickets = this.model.priceLists[0].prices.map(function(price) {
                return {
                  isRetail: price.isRetail,
                  ticketTypeId: price.personType.id,
                  name: price.personType.name,
                  quantity: price.quantity
                };
              });
            }

            return tickets;
          },

          getMemberOnlyCalloutMessage: function () {
            var self = $scope.event;

            return MembershipService.getMemberOnlyCalloutMessage(self.model);
          },

          success: {
            getHours: function(response) {
              var self = $scope.event;
              var membershipIds = self.membershipIds && self.membershipIds.split(',');
              var updateCart = false;

              self.hours = response.data.payload;
              // Auto select if there is only one showing
              if (self.autoSelectTime) {
                self.showHours = false;
                self.autoSelect();
              }else if (self.hours) {
                self.showHours = (self.hours.length > 1);
                self.chooseHour(self.getFirstAvailableTime(self.hours), updateCart);
              }
              // Get membership level information for discounts
              if (membershipIds instanceof Array && membershipIds.length || self.model.membershipCategoryId) {
                self.getDiscountedPricesForMember();
              }else{
                self.isLoaded = true;
              }

              self.eventHoursLoaded = true;
            },

            getComboHours: function(response) {
              // Handled inline
            },

            getDiscountedPricesForMember: function(response) {
              var data,
                  self = $scope.event;

              self.isLoaded = true;

              try {
                data = JSON.parse(response.data.payload);
                self.memberDiscountedPriceMap = self.processMemberDiscountPrices(data);
              } catch (e) {
                console.log(e);
              }
            }
          },

          error: {
            getHours: function(response) {
              $scope.event.isLoaded = true;
              $scope.event.eventHoursLoaded = true;
            },
            getComboHours: function(response) {
              // Handled inline
            },
            getDiscountedPricesForMember: function(response) {
              $scope.event.isLoaded = true;
            }
          },

          onSumUpdateTotal: function(e, data) {
            const self = $scope.event;
            const tickets = self.getTicketsForLimits();

            e.stopPropagation();
            self.updateTotal();
            self.computeGroupTicketLimits();
            self.hasLimitErrors = self.checkLimitErrors();
          },

          onOrdersUpdated: function(e, data) {
            console.log('Event::onOrderServiceUpdate', $scope.event.model.name, e, data);
            // If there is a GA prerequisite AND it is already shown hide prerequisites button
            $scope.event.checkPrerequisites();
          },

          onGAExistsUpdate: function(n, o) {
            console.log('Event::onGAExistsUpdate', n, o);
            // If there is a GA prerequisite AND it is already shown hide prerequisites button
            $scope.event.checkPrerequisites();

          },

          onAvailableSeatsUpdate: function(n, o) {},

          onOrdersUpdatedLimits: function(e, data) {
            var self = $scope.event,
              tickets = self.getTicketsForLimits();

            self.memberTicketLimitMap = SalesRuleService.getMemberTicketLimit(tickets, self.selectedHourId);
            self.memberGroupLimitMap = SalesRuleService.getMemberGroupLimit(tickets, self.selectedHourId);

            self.computeGroupTicketLimits();

            self.hasLimitErrors = self.checkLimitErrors();

            $timeout(function(){
              $scope.$broadcast('Event::updatedLimits');
            },0);
          }

        };

        $scope.combo = {
          init: function() {

          }
        };


        $scope.combo.init();
        $scope.event.init();

      }]

    };

}]).name;
